import { connect } from 'react-redux'
import { IGlobalState } from '../../../../Root/store/appReducer'
import { markUserNotificationRead } from '../../store/InboxActions'
import UserNotification, { IUserNotification, IUserNotificationDispatchProps } from './UserNotification'

const mapStateToProps = (state: IGlobalState, ownProps: any): IUserNotification => ({
  notification: ownProps.notification,
  isOpen: ownProps.isOpen,
  isLast: ownProps.isLast,
})

const mapDispatchToProps: IUserNotificationDispatchProps = {
  markUserNotificationRead,
}

export default connect(mapStateToProps, mapDispatchToProps)(UserNotification)
